/* pdp-bundle.js - the PDP bundle widget (sections/pdp-bundle.liquid).

   What makes it worth building instead of installing an FBT app: every row can
   be configured the way the product page itself configures a jersey - size,
   free name and number, patch - and all of it is added in one request, in the
   line-item property contract the cart-transform function already understands
   (_bundle_id / _bundle_role / _עבור). The main product is not re-configured
   here, it is mirrored from the form above, so the same product can never be
   added twice.

   Motion: springs from apple-motion.js. A config panel can be collapsed while
   it is still opening, and it continues from the height currently on screen -
   the reason no CSS transition touches height here. Under
   prefers-reduced-motion the springs are skipped entirely and the panel just
   appears, which is the accessible equivalent, not a degraded one.

   Money: this widget never invents a discount. The total is the plain sum of
   what the button is about to add, and a struck-through figure only ever comes
   from a real compare_at_price emitted by Liquid. */
(function () {
  'use strict';

  var root = document.querySelector('[data-jrsb-root]');
  if (!root || window.JRSBundle) return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── helpers ─────────────────────────────────────────────────────────────── */

  function fmt(cents) {
    return '₪' + Math.round(cents / 100).toLocaleString('he-IL');
  }
  function num(el, attr) { return parseInt(el.getAttribute(attr), 10) || 0; }

  /* Height spring. AppleMotion is loaded defer alongside this file; if it ever
     is not there, fall through to an instant open rather than a dead panel. */
  function reveal(panel, open, onRest) {
    if (!panel) return;
    if (REDUCE || !window.AppleMotion) {
      panel.hidden = !open;
      panel.style.height = '';
      if (onRest) onRest();
      return;
    }
    if (open) panel.hidden = false;
    var from = panel.getBoundingClientRect().height;
    /* Measure the panel itself at auto height. Reading firstElementChild only
       worked for panels built around a single wrapper - the print panel holds
       two sibling fields, so it opened to the height of the name input alone. */
    var prev = panel.style.height;
    panel.style.height = 'auto';
    var to = open ? panel.scrollHeight : 0;
    panel.style.height = prev;
    if (panel._spring) panel._spring.stop();
    var s = window.AppleMotion.spring(function (v) {
      panel.style.height = v + 'px';
    }, function () {
      panel.style.height = open ? '' : '';
      if (!open) panel.hidden = true;
      if (onRest) onRest();
    });
    panel._spring = s;
    s.dynamics(1.0, 0.35);       // critically damped: a panel opening carries no momentum
    s.set(from);
    s.to(to);
  }

  /* ── item state ──────────────────────────────────────────────────────────── */

  var items = [].map.call(root.querySelectorAll('[data-jrsb-item]'), function (el) {
    var sizes = el.querySelector('[data-jrsb-sizes]');
    var fixed = el.querySelector('[data-jrsb-fixed-variant]');
    var simple = el.classList.contains('jrsb-item--simple');
    return {
      el: el,
      handle: el.dataset.handle,
      title: el.dataset.title,
      type: el.dataset.type || '',
      sizeTouched: false,
      prefilled: false,
      src: el.dataset.src,
      simple: simple,
      cfg: el.querySelector('[data-jrsb-cfg]'),
      summaryEl: el.querySelector('[data-jrsb-summary]'),
      priceEl: el.querySelector('[data-jrsb-item-price]'),
      /* Price is read for every row now. It used to be emitted only for rows
         with no config panel, so a configurable row without a size selector
         contributed ₪0 to the total while the cart charged it in full. */
      needsSize: !!sizes,
      variantId: sizes ? 0 : num(el, 'data-variant'),
      price: sizes ? 0 : num(el, 'data-price'),
      compare: sizes ? 0 : num(el, 'data-compare'),
      sizeLabel: '',
      name: '',
      number: '',
      /* Patch, player-version upgrade and matching shorts / socks / long
         sleeves are all the same thing to the cart: a separate product that
         rides under this row's _bundle_id. One list, one code path. */
      addons: [],
      // Pre-ticking is decided below: exactly one accessory row, so the first
      // number on screen is close to the truth. Pre-ticking every one-size row
      // made a Portland jersey open at ₪397 of mostly irrelevant items.
      on: false,
    };
  });

  /* One pre-tick, and only for a row that needs nothing configured: it is a
     genuine one-tap yes and it keeps the strip from opening at zero. */
  (function () {
    for (var i = 0; i < items.length; i++) {
      if (!items[i].needsSize && items[i].variantId) { items[i].on = true; return; }
    }
  }());

  var els = {
    total: root.querySelector('[data-jrsb-total]'),
    totalCompare: root.querySelector('[data-jrsb-total-compare]'),
    count: root.querySelector('[data-jrsb-count]'),
    cta: root.querySelector('[data-jrsb-add]'),
    ctaText: root.querySelector('[data-jrsb-cta-text]'),
    err: root.querySelector('[data-jrsb-err]'),
    promo: root.querySelector('[data-jrsb-promo]'),
    mirrorSummary: root.querySelector('[data-jrsb-mirror-summary]'),
    mirrorPrice: root.querySelector('[data-jrsb-mirror-price]'),
    mirrorImg: root.querySelector('[data-jrsb-mirror-img]'),
  };

  var mainVariants = (function () {
    var tag = root.querySelector('[data-jrsb-main-variants]');
    try { return tag ? JSON.parse(tag.textContent) : []; } catch (e) { return []; }
  }());

  /* ── the main product, read from the form above ──────────────────────────── */

  function mainState() {
    var idEl = document.getElementById('variant-id');
    var vid = idEl ? parseInt(idEl.value, 10) : 0;
    var v = null;
    for (var i = 0; i < mainVariants.length; i++) if (mainVariants[i].id === vid) v = mainVariants[i];
    var price = v ? v.p : num(root, 'data-main-price');
    var compare = v && v.c > v.p ? v.c : 0;

    var addons = 0;
    document.querySelectorAll('#metafield-patches .active[data-addon-price],#metafield-version .active[data-addon-price]')
      .forEach(function (b) { addons += parseInt(b.dataset.addonPrice, 10) || 0; });
    document.querySelectorAll('.pdp2-addon-card__input:checked')
      .forEach(function (i) { addons += parseInt(i.dataset.price, 10) || 0; });

    var sizeBtn = document.querySelector('.size-selector .pdp2-pill.active');
    var nameEl = document.getElementById('line-item-name');
    var numEl = document.getElementById('line-item-number');
    var patchLbl = document.getElementById('selected-patch');

    return {
      variantId: vid,
      price: price,
      compare: compare,
      addons: addons,
      size: sizeBtn ? sizeBtn.dataset.value : '',
      name: nameEl ? nameEl.value.trim() : '',
      number: numEl ? numEl.value.trim() : '',
      patch: patchLbl && patchLbl.textContent.trim() !== 'ללא' ? patchLbl.textContent.trim() : '',
    };
  }

  function chips(list) {
    return list.filter(Boolean).map(function (t) { return '<span>' + t + '</span>'; }).join('');
  }

  function renderMirror() {
    var m = mainState();
    if (els.mirrorSummary) {
      var html = chips([m.size, m.name, m.number ? '#' + m.number : '', m.patch]);
      els.mirrorSummary.innerHTML = html;
      els.mirrorSummary.hidden = !html;
    }
    if (els.mirrorPrice) {
      els.mirrorPrice.innerHTML =
        (m.compare > m.price ? '<s><bdi>' + fmt(m.compare + m.addons) + '</bdi></s>' : '') +
        '<bdi>' + fmt(m.price + m.addons) + '</bdi>';
    }
    syncMirrorSize();
    prefillSizes();
    var mainImg = document.getElementById('main-product-image');
    if (els.mirrorImg && mainImg && mainImg.src) els.mirrorImg.src = mainImg.src.replace(/width=\d+/, 'width=200');
  }

  /* ── The main product's size, inside the widget ───────────────────────────
     The bundle button adds the main product too, so the page's size gate
     applies to it - and a shopper who scrolled straight into this widget has
     not touched the selector far above. That combination made the button look
     dead: the gate blocked, the page nudged something off-screen, the cart
     never changed. Rather than send them back up, the mirror row grows its own
     size pills, cloned from the real selector and clicking straight through to
     it, so the page keeps exactly one source of truth for the chosen variant. */
  var mirrorSizeWrap = null;

  function mainSizePills() { return [].slice.call(document.querySelectorAll('.size-selector .pdp2-pill')); }
  function mainSizeMissing() { return mainSizePills().length > 0 && !document.querySelector('.size-selector .pdp2-pill.active'); }

  function buildMirrorSize() {
    var pills = mainSizePills();
    if (!pills.length) return;
    var mirror = root.querySelector('.jrsb-item--mirror .jrsb-item__main');
    if (!mirror) return;
    mirrorSizeWrap = document.createElement('div');
    mirrorSizeWrap.className = 'jrsb-field jrsb-mirror-size';
    mirrorSizeWrap.hidden = true;
    var label = document.createElement('span');
    label.className = 'jrsb-field__label';
    label.textContent = 'בחרו מידה';
    var box = document.createElement('div');
    box.className = 'jrsb-pills';
    pills.forEach(function (src) {
      if (src.disabled || src.classList.contains('is-out')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jrsb-pill';
      b.textContent = src.textContent.trim();
      b.setAttribute('aria-label', 'מידה ' + (src.dataset.value || src.textContent.trim()));
      b.addEventListener('click', function () {
        src.click();                       // the real selector stays in charge
        syncMirrorSize();
        renderMirror();
        render();
      });
      box.appendChild(b);
    });
    mirrorSizeWrap.appendChild(label);
    mirrorSizeWrap.appendChild(box);
    mirror.appendChild(mirrorSizeWrap);
  }

  /* Carry the shopper's size across to a row of the SAME product_type. A man
     who picked L is buying an L second shirt; he is not buying a size 24 kids
     kit, which is why the match is on the exact type and never on a family.
     The row is left unticked - only the size is made ready - and any size the
     shopper touches themselves is never overwritten. */
  function prefillSizes() {
    var active = document.querySelector('.size-selector .pdp2-pill.active');
    if (!active) return;
    var want = (active.dataset.value || '').trim();
    var anchorType = root.dataset.anchorType || '';
    if (!want || !anchorType) return;
    items.forEach(function (it) {
      if (!it.needsSize || it.sizeTouched || it.type !== anchorType) return;
      var match = null;
      it.el.querySelectorAll('[data-jrsb-size]').forEach(function (b) {
        if (!match && (b.dataset.value || '').trim() === want) match = b;
      });
      if (!match || it.sizeLabel === want) return;
      it.el.querySelectorAll('[data-jrsb-size]').forEach(function (b) { b.classList.remove('is-on'); });
      match.classList.add('is-on');
      it.variantId = num(match, 'data-variant');
      it.price = num(match, 'data-price');
      it.compare = num(match, 'data-compare');
      it.sizeLabel = want;
      it.prefilled = true;
    });
  }

  function syncMirrorSize() {
    if (!mirrorSizeWrap) return;
    var missing = mainSizeMissing();
    mirrorSizeWrap.hidden = !missing;
    var active = document.querySelector('.size-selector .pdp2-pill.active');
    var wanted = active ? active.textContent.trim() : null;
    mirrorSizeWrap.querySelectorAll('.jrsb-pill').forEach(function (b) {
      b.classList.toggle('is-on', !!wanted && b.textContent.trim() === wanted);
    });
  }

  /* ── totals ──────────────────────────────────────────────────────────────── */

  function render() {
    var m = mainState();
    var total = m.price + m.addons;
    var compare = (m.compare > m.price ? m.compare : m.price) + m.addons;
    var count = 1;

    items.forEach(function (it) {
      it.el.classList.toggle('is-on', it.on);
      var btn = it.el.querySelector('[data-jrsb-toggle]');
      if (btn) btn.setAttribute('aria-pressed', it.on ? 'true' : 'false');

      var extras = it.addons.reduce(function (sum, a) { return sum + a.price; }, 0);

      if (it.summaryEl) {
        var html = chips([it.sizeLabel, it.name, it.number ? '#' + it.number : '']
          .concat(it.addons.map(function (a) { return a.label; })));
        // A ticked row with no size contributes nothing to the total yet. Say so
        // in the row instead of letting the sum look quietly wrong.
        if (it.on && !it.variantId) html = '<span class="jrsb-need">בחרו מידה</span>' + html;
        it.summaryEl.innerHTML = html;
        it.summaryEl.hidden = !html;
      }
      if (it.priceEl && it.price) {
        // extras go on BOTH sides, or the struck figure ends up lower than the
        // price beside it and reads as a broken discount
        it.priceEl.innerHTML =
          (it.compare > it.price ? '<s><bdi>' + fmt(it.compare + extras) + '</bdi></s>' : '') +
          '<bdi>' + fmt(it.price + extras) + '</bdi>';
      }
      if (!it.on || !it.variantId) return;   // unresolved rows are not in the sum, so not in the count either
      count++;
      total += it.price + extras;
      compare += (it.compare > it.price ? it.compare : it.price) + extras;
    });

    els.total.textContent = fmt(total);
    if (els.totalCompare) {
      var show = compare > total;
      els.totalCompare.hidden = !show;
      if (show) els.totalCompare.innerHTML = '<bdi>' + fmt(compare) + '</bdi>';
    }
    els.count.textContent = 'סה״כ הפריטים שנבחרו (' + count + (count === 1 ? ' פריט)' : ' פריטים)');
    renderPromo(count);
    // The blocking message belongs to a state, not to a click: once every ticked
    // row has a size it must go, or it sits there contradicting a valid bundle.
    if (els.err && !els.err.hidden && !blockedItem()) els.err.hidden = true;
    els.ctaText.textContent = count > 1 ? 'הוסיפו את החבילה לעגלה' : 'הוסיפו לעגלה';
  }

  /* The store runs an automatic 3+1 (buy 3, cheapest of 4 free) enforced by
     Shopify, and this strip can reach four eligible lines in one tap. Saying
     nothing meant quoting a total ABOVE what checkout charges. The line below
     never restates a price - it only reports progress toward a discount the
     server already owns, using the drawer's own settings so the two can never
     disagree. */
  function renderPromo(count) {
    var el = els.promo;
    if (!el) return;
    var cfg = window.JERSEYS_CART || {};
    if (cfg.promoEnabled === false) { el.hidden = true; return; }
    var need = (cfg.promoQty || 3) + 1;
    if (count >= need) {
      el.textContent = 'הפריט הזול מבין ' + need + ' הפריטים יינתן במתנה בעגלה';
      el.hidden = false;
    } else if (count === need - 1) {
      el.textContent = 'עוד פריט אחד ומקבלים את הזול מביניהם במתנה';
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  /* ── interactions ────────────────────────────────────────────────────────── */

  function setOn(it, on, opts) {
    if (on) it.el.classList.remove('is-added');
    it.on = on;
    if (it.cfg) reveal(it.cfg, on);
    if (on && it.needsSize && !it.variantId && !(opts && opts.silent)) {
      var first = it.el.querySelector('[data-jrsb-size]');
      if (first) first.focus({ preventScroll: true });
    }
    render();
  }

  items.forEach(function (it) {
    var toggle = it.el.querySelector('[data-jrsb-toggle]');
    if (toggle) toggle.addEventListener('click', function () { setOn(it, !it.on); });

    /* Tapping anywhere in the row header toggles it. The checkbox stays the
       thing you see and the thing a screen reader operates; this just stops the
       thumb from having to find a 22px square. */
    var head = it.el.querySelector('.jrsb-item__head');
    if (head) head.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('[data-jrsb-toggle]')) return;
      setOn(it, !it.on);
    });

    it.el.querySelectorAll('[data-jrsb-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        it.el.querySelectorAll('[data-jrsb-size]').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        it.variantId = num(btn, 'data-variant');
        it.price = num(btn, 'data-price');
        it.compare = num(btn, 'data-compare');
        it.sizeLabel = btn.dataset.value;
        it.sizeTouched = true;
        if (it.prefilled) it.prefillOverridden = true;   // the falsification test for this feature
        var hint = it.el.querySelector('[data-jrsb-size-hint]');
        if (hint) hint.textContent = btn.dataset.value !== btn.textContent.trim() ? btn.dataset.value : '';
        it.el.classList.remove('is-shake');
        // Picking a size IS the intent to buy it - no second tap to confirm.
        if (!it.on) setOn(it, true, { silent: true });
        else render();
      });
    });

    var printBtn = it.el.querySelector('[data-jrsb-print-toggle]');
    var printBox = it.el.querySelector('[data-jrsb-print]');
    if (printBtn && printBox) {
      printBtn.addEventListener('click', function () {
        var open = printBtn.getAttribute('aria-expanded') !== 'true';
        printBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        reveal(printBox, open, function () {
          if (open) { var f = printBox.querySelector('[data-jrsb-name]'); if (f) f.focus({ preventScroll: true }); }
        });
        // Re-measure the row: the print panel grows inside the config panel.
        if (it.cfg && it.on) setTimeout(function () { it.cfg.style.height = ''; }, 0);
      });
    }
    var nameIn = it.el.querySelector('[data-jrsb-name]');
    if (nameIn) nameIn.addEventListener('input', function () {
      var s = this.selectionStart, e = this.selectionEnd;
      this.value = this.value.toUpperCase();
      this.setSelectionRange(s, e);
      it.name = this.value.trim();
      render();
    });
    var numIn = it.el.querySelector('[data-jrsb-number]');
    if (numIn) numIn.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 3);
      it.number = this.value;
      render();
    });

    /* Patch and version are radio-like (one league badge, one fabric), the
       accessories are not - a shopper can want shorts AND socks. The group
       lives in the markup so this stays one handler. */
    var SINGLE = { patch: true, version: true };
    it.el.querySelectorAll('[data-jrsb-addon]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.dataset.group;
        var was = btn.classList.contains('is-on');
        if (SINGLE[group]) {
          it.el.querySelectorAll('[data-jrsb-addon][data-group="' + group + '"]').forEach(function (b) { b.classList.remove('is-on'); });
          it.addons = it.addons.filter(function (a) { return a.group !== group; });
        }
        if (was) {
          btn.classList.remove('is-on');
          it.addons = it.addons.filter(function (a) { return a.id !== num(btn, 'data-variant'); });
        } else {
          btn.classList.add('is-on');
          it.addons.push({ id: num(btn, 'data-variant'), price: num(btn, 'data-price'), label: btn.dataset.label, group: group });
        }
        render();
      });
    });
  });

  /* The mirror row follows the form above. One delegated listener on the
     product section plus the inputs - cheaper than observing a 2,700-line
     subtree, and it fires on exactly the interactions that change the mirror. */
  ['click', 'change', 'input'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('.pdp2, #product-form, .pdp2__sticky')) {
        clearTimeout(root._mirrorT);
        root._mirrorT = setTimeout(function () { renderMirror(); render(); }, 30);
      }
    }, true);
  });

  /* ── add to cart ─────────────────────────────────────────────────────────── */

  function bid() { return 'b' + Date.now() + Math.floor(Math.random() * 1000); }

  function mainItems() {
    // The single source of truth for the main product's line items lives in
    // sections/product-v4.liquid; duplicating that property contract here is
    // how the two drift apart.
    if (window.JRSPdp && window.JRSPdp.buildMainItems) return window.JRSPdp.buildMainItems();
    var idEl = document.getElementById('variant-id');
    var qtyEl = document.getElementById('qty-input');
    if (!idEl) return [];
    return [{ id: parseInt(idEl.value, 10), quantity: parseInt(qtyEl && qtyEl.value, 10) || 1, properties: {} }];
  }

  function bundleItems() {
    var out = [];
    items.forEach(function (it) {
      if (!it.on || !it.variantId) return;
      var props = {};
      if (it.name) props['שם'] = it.name;
      if (it.number) props['מספר'] = it.number;
      /* Underscore keys stay out of checkout but ride into the order, so the
         recommender can score its own rows later and the order data can tell a
         widget-driven second shirt from an organic one. Without it the model
         reads its own output back as evidence next window. */
      props._bundle_src = root.dataset.anchorHandle || '';
      props._bundle_evidence = it.src || '';
      if (!it.addons.length) {
        // No addons means no bundle to merge - a plain line keeps the cart honest.
        out.push({ id: it.variantId, quantity: 1, properties: props });
        return;
      }
      var id = bid();
      props._bundle_id = id;
      props._bundle_role = 'parent';
      props._addons = it.addons.map(function (a) { return a.label; }).join('|');
      out.push({ id: it.variantId, quantity: 1, properties: props });
      var forLabel = it.title + (it.sizeLabel ? ' - ' + it.sizeLabel : '');
      it.addons.forEach(function (a) {
        out.push({
          id: a.id, quantity: 1,
          properties: { _bundle_id: id, _bundle_role: 'addon', '_עבור': forLabel },
        });
      });
    });
    return out;
  }

  function blockedItem() {
    for (var i = 0; i < items.length; i++) if (items[i].on && !items[i].variantId) return items[i];
    return null;
  }

  /* ~40% of this store's traffic is in-app webviews where the pixel is often
     blocked or missing, which is why cart-drawer.js fans its events out. Same
     shape here, each sink guarded on its own. */
  function track(name, payload) {
    try { if (window.fbq) window.fbq('trackCustom', name, payload); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload)); } catch (e) {}
    try { if (window.clarity) window.clarity('event', name); } catch (e) {}
  }

  els.cta.addEventListener('click', function () {
    var blocked = blockedItem();
    if (blocked) {
      els.err.textContent = 'בחרו מידה עבור ' + (blocked.title || 'הפריט');
      els.err.hidden = false;
      blocked.el.classList.remove('is-shake');
      void blocked.el.offsetWidth;
      blocked.el.classList.add('is-shake');
      blocked.el.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' });
      var s = blocked.el.querySelector('[data-jrsb-size]');
      if (s) s.focus({ preventScroll: true });
      return;
    }
    els.err.hidden = true;

    // The page's own gate decides whether the main product needs a size; this
    // just refuses to swallow the refusal. Before, it called nudge() and
    // returned - from down here that is a button that does nothing.
    if (window.__jrsSizeGate && window.__jrsSizeGate.blocked()) {
      els.err.textContent = 'בחרו מידה למוצר הראשי כדי להוסיף את החבילה';
      els.err.hidden = false;
      syncMirrorSize();
      var mirrorRow = root.querySelector('.jrsb-item--mirror');
      if (mirrorSizeWrap && !mirrorSizeWrap.hidden) {
        mirrorRow.classList.remove('is-shake');
        void mirrorRow.offsetWidth;
        mirrorRow.classList.add('is-shake');
        mirrorRow.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' });
        var first = mirrorSizeWrap.querySelector('.jrsb-pill');
        if (first) first.focus({ preventScroll: true });
      } else if (window.__jrsSizeGate.nudge) {
        window.__jrsSizeGate.nudge();
      }
      return;
    }

    var payload = mainItems().concat(bundleItems());
    if (!payload.length) return;

    var selected = items.filter(function (it) { return it.on && it.variantId; });
    els.cta.disabled = true;
    var original = els.ctaText.textContent;
    els.ctaText.textContent = 'מוסיף לעגלה...';

    var addedValue = selected.reduce(function (sum, it) {
      return sum + it.price + it.addons.reduce(function (a, x) { return a + x.price; }, 0);
    }, 0);
    /* This object is named `analytics` on purpose. It used to reuse the name of
       the line-items array above, shadowed it, and the add request went out
       carrying tracking data instead of the cart lines - so nothing was added. */
    var analytics = {
      items: selected.length + 1,
      value: Math.round(addedValue / 100),          // incremental shekels, not the whole basket
      handles: selected.map(function (it) { return it.handle; }).join(','),
      src: selected.map(function (it) { return it.src; }).join(','),
      sizes: selected.map(function (it) { return it.sizeLabel || '-'; }).join(','),
      prefilled: selected.filter(function (it) { return it.prefilled; }).length,
      prefill_overridden: selected.filter(function (it) { return it.prefillOverridden; }).length,
    };

    var done = function () {
      // fired here, not before the request: a failed add was being counted as one
      track('JRS_BundleAdd', analytics);
      els.cta.disabled = false;
      els.ctaText.textContent = original;
      /* The page's own addon cards, running total, kit card and sticky tags are
         still showing the configuration that was just bought. Left alone, the
         shopper sees an unchanged page, presses the page's own add-to-cart and
         pays for the jersey and its addons twice. */
      document.querySelectorAll('.pdp2-addon-card__input:checked').forEach(function (i) {
        i.checked = false;
        var card = i.closest('.pdp2-addon-card');
        if (card) card.classList.remove('active');
      });
      try { if (window.JRSKit && window.JRSKit.render) window.JRSKit.render(); } catch (e) {}
      try { if (window.updateRunningTotal) window.updateRunningTotal(); } catch (e) {}
      try { if (window.updateStickyTags) window.updateStickyTags(); } catch (e) {}
      selected.forEach(function (it) {
        it.el.classList.add('is-added');
        setOn(it, false, { silent: true });
      });
      document.dispatchEvent(new CustomEvent('cart:jersey-added', { detail: { collections: [] } }));
      if (window.CartAPI && window.CartAPI.open) window.CartAPI.open();
      else document.dispatchEvent(new CustomEvent('cart:open'));
    };
    var fail = function () {
      els.cta.disabled = false;
      els.ctaText.textContent = 'שגיאה, נסו שוב';
      setTimeout(function () { els.ctaText.textContent = original; }, 2200);
    };

    if (window.CartAPI && window.CartAPI.add) window.CartAPI.add(payload).then(done).catch(fail);
    else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: payload }),
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); }).then(done).catch(fail);
    }
  });

  /* One view event per page, only once the widget is actually on screen. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        track('JRS_BundleView', {
          items: items.length,
          src: items.map(function (it) { return it.src; }).join(','),
        });
      });
      // threshold 0.4 of the SECTION never resolves once a row opens: the strip
      // grows past the viewport and the ratio cannot reach it
    }, { threshold: 0, rootMargin: '0px 0px -25% 0px' });
    io.observe(root);
  }

  /* ── Yield the PDP's sticky add-to-cart bar ───────────────────────────────
     It is fixed over the bottom of the viewport, so while the shopper works
     inside this widget it sat on top of exactly the row they were configuring.
     Measured per frame instead of via IntersectionObserver because the trigger
     is a geometric overlap with the bar's own band, not a threshold on this
     element - and the bar's height changes when it shows its size row. */
  (function () {
    var bar = document.getElementById('sticky-atc');
    if (!bar) return;
    var queued = false;
    function sync() {
      queued = false;
      /* Yield for the footer and for any panel the shopper has open - not for
         the strip's whole height. On a four-row strip that hid the store's main
         buy button for a viewport and a half of scrolling. */
      var band = window.innerHeight - (bar.offsetHeight + 24);
      var zones = [root.querySelector('.jrsb__foot')];
      root.querySelectorAll('[data-jrsb-cfg]').forEach(function (c) { if (!c.hidden) zones.push(c); });
      var hit = zones.some(function (el) {
        if (!el) return false;
        var r = el.getBoundingClientRect();
        return r.bottom > band && r.top < window.innerHeight;
      });
      bar.classList.toggle('jrsb-yield', hit);
    }
    function request() { if (!queued) { queued = true; requestAnimationFrame(sync); } }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    root.addEventListener('click', request);   // opening a row changes its height
    sync();
  }());

  items.forEach(function (it) { if (it.on && it.cfg) it.cfg.hidden = true; });
  buildMirrorSize();
  prefillSizes();
  renderMirror();
  render();

  window.JRSBundle = { items: items, render: render };
}());
